'use client';

import { useState } from 'react';
import { Box, Group, Stack, Text } from '@mantine/core';
import { useLayoutHorizontalSpacing } from '@/src/app/_hooks/use-layout-horizontal-spacing';
import { PrivacyAndPolicy } from '@/src/app/(auth)/register/_components/privacy-and-policy';
import { TermsAndConditions } from '@/src/app/(auth)/register/_components/terms-and-conditions';

export function Footer() {
  const layoutHorizontalSpacing = useLayoutHorizontalSpacing();
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const [openPrivacyModal, setOpenPrivacyModal] = useState(false);

  return (
    <Box bg="white" py="xl" className="border-t border-gray-200">
      {/* <Box
        className="mb-12 grid grid-cols-1 gap-8 md:grid-cols-4"
        px={layoutHorizontalSpacing}
      >
        <div className="md:col-span-1">
          <Text fw={700} size="xl" className="mb-4 text-teal-700">
            Marketplace
          </Text>
          <Text size="sm" c="dimmed" className="max-w-xs">
            Platform kesehatan terpercaya untuk kebutuhan Anda dan keluarga.
          </Text>
        </div>

        <div>
          <Text fw={700} size="lg" mb="md">
            Tentang Kami
          </Text>
          <Stack gap="xs">
            <Text
              size="sm"
              c="dimmed"
              component={Link}
              href="#"
              className="hover:text-teal-600"
            >
              Tentang Marketplace
            </Text>
            <Text
              size="sm"
              c="dimmed"
              component={Link}
              href="#"
              className="hover:text-teal-600"
            >
              Karir
            </Text>
            <Text
              size="sm"
              c="dimmed"
              component={Link}
              href="#"
              className="hover:text-teal-600"
            >
              Blog
            </Text>
            <Text
              size="sm"
              c="dimmed"
              component={Link}
              href="#"
              className="hover:text-teal-600"
            >
              Kebijakan Privasi
            </Text>
          </Stack>
        </div>

        <div>
          <Text fw={700} size="lg" mb="md">
            Layanan Pelanggan
          </Text>
          <Stack gap="xs">
            <Text
              size="sm"
              c="dimmed"
              component={Link}
              href="#"
              className="hover:text-teal-600"
            >
              Bantuan
            </Text>
            <Text
              size="sm"
              c="dimmed"
              component={Link}
              href="#"
              className="hover:text-teal-600"
            >
              Metode Pembayaran
            </Text>
            <Text
              size="sm"
              c="dimmed"
              component={Link}
              href="#"
              className="hover:text-teal-600"
            >
              Lacak Pesanan
            </Text>
            <Text
              size="sm"
              c="dimmed"
              component={Link}
              href="#"
              className="hover:text-teal-600"
            >
              Hubungi Kami
            </Text>
          </Stack>
        </div>

        <div>
          <Text fw={700} size="lg" mb="md">
            Ikuti Kami
          </Text>
          <Group gap="md">
            <ActionIcon size="lg" variant="subtle" color="gray">
              <IconBrandTwitter size={18} stroke={1.5} />
            </ActionIcon>
            <ActionIcon size="lg" variant="subtle" color="gray">
              <IconBrandYoutube size={18} stroke={1.5} />
            </ActionIcon>
            <ActionIcon size="lg" variant="subtle" color="gray">
              <IconBrandInstagram size={18} stroke={1.5} />
            </ActionIcon>
          </Group>
        </div>
      </Box> */}

      <Group gap="xs" px={layoutHorizontalSpacing} justify="space-between">
        <Text c="dimmed" size="sm">
          © 2026 HealthyOne Marketplace. All rights reserved.
        </Text>

        <Group gap="md">
          <Text
            onClick={(e) => {
              e.stopPropagation();
              setOpenTermsModal(true);
            }}
            c="dimmed"
            size="sm"
          >
            Syarat & Ketentuan
          </Text>

          <Text
            onClick={(e) => {
              e.stopPropagation();
              setOpenPrivacyModal(true);
            }}
            c="dimmed"
            size="sm"
          >
            Kebijakan Privasi
          </Text>

          <Text c="dimmed" size="sm">
            Indonesia
          </Text>
        </Group>
      </Group>
      <Stack>
        <TermsAndConditions
          openModal={openTermsModal}
          setOpenModal={setOpenTermsModal}
        />
        <PrivacyAndPolicy
          openModal={openPrivacyModal}
          setOpenModal={setOpenPrivacyModal}
        />
      </Stack>
    </Box>
  );
}
